// extracted by mini-css-extract-plugin
export default {"storyDetailListWrapper":"c-r_gk","storyDetailListWrapper__title":"c-r_gl","storyDetailListWrapper__timeline":"c-r_gm","storyDetailListWrapper__list":"c-r_gn"};